import React from 'react'
import SliderBasic from '../SliderBasic'

const MainSliderSelection = ({
    attributeStyling, 
    selectionId, 
    features, 
    itemSelection, 
    itemCollections, 
    ads, 
    advertisements,
    movies, 
    weischerAds, 
    showAvailableIn,
    elbenwald,
    sliderSettings, 
    ignoreAttributesForPerformanceFilter,
    type, 
    hiddenAttributes,
    theme, 
    translation,
    sliderAppearance,
    smallSliderAppearance,
    moviesRoutesData, 
    informationStyling,
    mainSliderAdvertisementPositioning,
    detailsStyling,
    setIdForActiveSelection, 
    isConnectedFast,
    currentActiveSelection
}) => {
    if(!itemSelection) {
        return ''
    }

    const backgroundVisualsSettings = {
        style: itemSelection.style,
        trailerAutoplay: itemSelection.trailerAutoplay && features.has_trailer_views
    }
    const collectionId = itemSelection.collections[0]
    const collectionItems = itemCollections[collectionId] && itemCollections[collectionId].items ? itemCollections[collectionId].items : []

    return <SliderBasic
        mainSliderAdvertisementPositioning={mainSliderAdvertisementPositioning}
        attributeStyling={attributeStyling}
        showAvailableIn={showAvailableIn}
        informationStyling={informationStyling}
        hiddenAttributes={hiddenAttributes}
        detailsStyling={detailsStyling}
        ignoreAttributesForPerformanceFilter={ignoreAttributesForPerformanceFilter}
        sliderAppearance={sliderAppearance}
        smallSliderAppearance={smallSliderAppearance}
        type={type}
        theme={theme}
        features={features}
        settings = {sliderSettings}
        backgroundVisualsSettings={backgroundVisualsSettings}
        items = {collectionItems}
        translation={translation}
        moviesData = {movies}
        moviesRoutesData={moviesRoutesData}
        adsData = {ads}
        filterValue={null}
        filterType={null}
        advertisementsData={advertisements}
        weischerAdsData = {weischerAds}
        elbenwald={elbenwald}
        selectionId= {selectionId}
        scrollToPosition = {"slider-basic slider-basic-large " + selectionId}
        currentActiveSelection= {currentActiveSelection}
        isConnectedFast={isConnectedFast}
        setIdForActiveSelection= {setIdForActiveSelection}
        isFront={true}
        isMainSlider={true}
    />
}


export default MainSliderSelection